<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXSBBankCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.excmcyclictask.list.noTasks') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('views.exsbbank.list.title') }}</th>
            <th>{{ $t('views.exsbbank.list.description') }}</th>
            <th style="width: 5%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{ item.title }}</td>
            <td>{{ item.description }}</td>
            <td>
              <div class="btn-group">
                <router-link tag="button" class="btn btn-link fa fa-edit fa-lg" :to="{ name: 'EXSBBankUpdate', params: { id: item['@id'] }}"></router-link>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'List',
  components: {
    BaseTableWrapper,
    Pagination,
    Loader
  },

  computed: mapGetters({
    error: 'exsbbank/list/error',
    items: 'exsbbank/list/items',
    isLoading: 'exsbbank/list/isLoading',
    view: 'exsbbank/list/view'
  }),
  beforeCreate () {
    checkPagePermission('finances', 'EXSBBankList')
  },
  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'exsbbank/list/getItems'
  })
}
</script>

<style scoped>

</style>
